import React, { useContext } from "react";

export type CKFilterOnSelectParams<T> = {
  type: "checkbox" | "range";
  origin: T[];
  checked: boolean;
  current?: Partial<T>[];
};
export interface CKFilterContextProps<T = any> {
  value: T[];
  onUpdate(info: CKFilterOnSelectParams<T>): void;
  onUnCheck(origin: T[]): void;
  onChange(data: T[]): void;
  onReset(): void;
  ifChecked(item: T): boolean;
}

export const CKFilterContext = React.createContext<CKFilterContextProps>({
  value: [],
  onUpdate() {},
  onUnCheck() {},
  onReset() {},
  onChange() {},
  ifChecked: () => false,
});

export const useCKFilterContext = <T = any>() =>
  useContext(CKFilterContext) as CKFilterContextProps<T>;
